import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isEmpty } from '@partners/utils';
import { IRangeValidationHandler, TValidatorError } from '../../model';

export function specificLengthValidator(args: Partial<IRangeValidationHandler<number>>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;
    const { specific } = args;

    if (invalid) return null;
    if (isEmpty(value)) return null;

    const matchedLength = specific.find((length) => length === value.toString().length);

    const isOutOfRange = isEmpty(matchedLength);

    if (isOutOfRange) {
      const vldResponse: TValidatorError = { specificLength: value };
      return vldResponse;
    }

    return null;
  };
}
